// O que vale para a loja inteira (Configurações → Sistema → Preferências →
// Balança): modo automático ou manual, peso mínimo, módulos e o produto da
// pesagem rápida. Lido uma vez e guardado; quem salva avisa as telas abertas.
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const EVENTO = "nucleo:balanca-prefs";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

export const MODULOS_BALANCA = [
  { key: "Balcao", label: "Balcão" },
  { key: "Comandas", label: "Comandas" },
  { key: "Mesas", label: "Mesas" },
  { key: "Delivery", label: "Delivery" },
  { key: "Totem", label: "Totem" },
];

export const PREFS_PADRAO = { modo: "manual", peso_minimo_g: 20, modulos: MODULOS_BALANCA.map((m) => m.key), produto_pesagem_id: null };

let cache = null;
let buscando = null;

export function lerPrefs({ forcar = false } = {}) {
  if (cache && !forcar) return Promise.resolve(cache);
  if (buscando) return buscando;
  buscando = fetch(`${API_URL}/api/settings/balanca`, { headers: auth(), cache: "no-store" })
    .then((r) => (r.ok ? r.json() : PREFS_PADRAO))
    .catch(() => PREFS_PADRAO)
    .then((d) => {
      cache = { ...PREFS_PADRAO, ...d };
      return cache;
    })
    .finally(() => { buscando = null; });
  return buscando;
}

export async function salvarPrefs(mudancas) {
  const r = await fetch(`${API_URL}/api/settings/balanca`, { method: "PUT", headers: auth(), body: JSON.stringify(mudancas) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
  cache = { ...PREFS_PADRAO, ...d };
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: cache }));
  return cache;
}

export function usePrefsBalanca() {
  const [prefs, setPrefs] = useState(cache);
  useEffect(() => {
    let vivo = true;
    lerPrefs().then((p) => vivo && setPrefs(p));
    const h = (e) => setPrefs(e.detail);
    window.addEventListener(EVENTO, h);
    return () => { vivo = false; window.removeEventListener(EVENTO, h); };
  }, []);
  return prefs;
}
